import { Info, LocalOffer, Chat, Notifications, Phone, ConfirmationNumber, MailOutline, AccessTime, Star, Payment } from '@mui/icons-material';

// 顶部文字公告
const BANNER_ANNOUNCEMENT = [
    {
        key: 'el-icon-info',
        icon: <Info />,
    },
    {
        key: 'el-icon-price-tag',
        icon: <LocalOffer />,
    },
    {
        key: 'el-icon-chat-line-square',
        icon: <Chat />,
    },
    {
        key: 'el-icon-message-solid',
        icon: <Notifications />,
    },
    {
        key: 'el-icon-phone-outline',
        icon: <Phone />,
    },
    {
        key: 'el-icon-tickets',
        icon: <ConfirmationNumber />,
    },
    {
        key: 'el-icon-message',
        icon: <MailOutline />,
    },
    {
        key: 'el-icon-time',
        icon: <AccessTime />,
    },
    {
        key: 'el-icon-star-on',
        icon: <Star />,
    },
    {
        key: 'el-icon-s-management',
        icon: <Payment />,
    },

]
export default BANNER_ANNOUNCEMENT